import { AxiosCore } from "../utils/AxiosCore"


export const login = async(data) => {
    const response = await AxiosCore.post("/api/mabe-capacita/v1/auth/login", data);
    return response;
}

export const register = async(data) => {
    const response = await AxiosCore.post("/api/mabe-capacita/v1/auth/register", data);
    return response;
}

export const verifyOtp = async (data) => {
    const params = new URLSearchParams();
    params.append('id', data.id);
    params.append('otp', data.otpCode);

    return await AxiosCore.post(`/api/mabe-capacita/v1/otp/login?${params.toString()}`);
}

export const resendOtp = async (userId) => {
    return await AxiosCore.post(`/api/mabe-capacita/v1/otp/resend/${userId}`);
}

export const validateToken = async (token) =>{
    return await AxiosCore.post("/api/mabe-capacita/v1/auth/validateToken", {
        token: token
    });
}

export const getTrainingVideos = async () => {
    return await AxiosCore.get("/api/mabe-capacita/v1/training-videos/activeAndOrder");
};

export const getVideoById = async (id) => {
    return await AxiosCore.get("/api/mabe-capacita/v1/training-videos/"+id);
};